import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {getResourceFormat} from "../../../common";
import {faBolt} from '@fortawesome/free-solid-svg-icons';
import {IAppSettingsWrap, IResource, IResourcePreview, IResourceSharedItem} from "../../../interfaces";
import {AppService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {ImportService} from "../../../services/import.service";


@Component({
    selector: 'app-resources-importer',
    templateUrl: './resources-importer.component.html',
    styleUrls: ['./resources-importer.component.scss']
})
export class ResourcesImporterComponent extends Compbaser implements OnInit {

    @ViewChild("helperModal", {read: TemplateRef}) helperModal: TemplateRef<any>;

    readonly faBolt = faBolt;

    filter = '';
    helpModalDiag;
    m_sharedResources: Array<IResourcePreview> = [];
    // filteredResources: Array<IResourcePreview> = [];
    selectedResource: IResourcePreview;
    coreAppData: IAppSettingsWrap;
    imageLoading = true;
    ready = false;
    resourceShortcuts = {};

    @Input() dialogGetAsset;
    
    @Input()
    set sharedResources(i_resources: Array<IResourceSharedItem>) {
        this.m_sharedResources = [];
        if (i_resources) {
            i_resources.forEach((r, index) => {
                const res = getResourceFormat(r.$);
                res.resourceId = r.$.resourceId;
                res.businessId = r.$.businessId;
                res.name = r.$.resourceName;
                res.treePath = r.$.treePath;
                res.resourceType = r.$.resourceType;
                if (!res.url) res.url = r.url;
                res.show = true;
                if (res.resourceType === 'mp4') {
                    res.videoUrl = r.url;
                }
                if (Object.keys(this.resourceShortcuts).length > 0) {
                    res.imported = !!this.resourceShortcuts[res.businessId + '.' + res.resourceId];
                }
                // if (res.resourceType === 'svg') {
                //     const getResource: IResource = {
                //         resource_type: 'svg',
                //         id: r.$.resourceId,
                //         resource_id: r.$.resourceId,
                //         shortcut_resource_id: r.$.resourceId,
                //         tree_path: '',
                //         shortcut_business_id: r.$.businessId,
                //         resource_pixel_width: '-1',
                //         resource_pixel_height: '-1',
                //         resource_total_time: '-1',
                //         resource_date_created: '-1',
                //         resource_date_modified: '-1',
                //         resource_public: 'true',
                //         resource_bytes_total: '-1',
                //         access_key: '',
                //         shortcut: '',
                //         resource_name: '',
                //         change_type: null,
                //         changelist_id: ''
                //     };
                //     // use to test gpu on and off
                //     const resourcePreview: IResourcePreview = getResourcePreview(getResource, this.coreAppData, false, r.$.businessId);
                //     res.type = 'svg';
                // }
                this.m_sharedResources.push(res);
            });
            this.ready = true;
        }
    }

    @Output() itemSelected = new EventEmitter<string>();

    constructor(private storeSelector: StoreSelectorsService,
                protected override dialog: MatDialog,
                private localStoreService: LocalStoreService,
                private router: Router,
                private appService: AppService,
                private importService: ImportService) {
        super(dialog);
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getResources(false).subscribe((resources: IResource[]) => {
                resources.forEach(r => {
                    if (r.shortcut_business_id != null && r.shortcut_business_id != "") {
                        const key = r.shortcut_business_id + '.' + r.shortcut_resource_id;
                        this.resourceShortcuts[key] = r.resource_id;
                    }
                });
                this.updateResoures();
            })    
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
    }

    private updateResoures() {
        this.m_sharedResources.forEach((res) => {
            const uniqueKey = res.businessId + '.' + res.resourceId;
            res.imported = !!this.resourceShortcuts[uniqueKey];
        })
    }

    openImportDialog(i_resource: IResourcePreview) {
        if (i_resource.imported) return;

        this.selectedResource = i_resource;
        this.helpModalDiag = this.dialog.open(this.helperModal, {
            width: '600px',
            height: '60%',
            data: {
                callBack: (data) => {
                    this.helpModalDiag.close();
                }
            }
        });
        this.helpModalDiag.afterClosed().subscribe(result => {
            this.imageLoading = true;
        });
    }

    applyFilter(filterValue: string) {
        this.m_sharedResources.forEach((v) => {
            try {
                if (v.name.toLowerCase().match(filterValue.toLowerCase())) {
                    v.show = true;
                } else {
                    v.show = false;
                }
            } catch (e) {
                v.show = true;
            }
        });
    }

    onLoad(e) {
        this.imageLoading = false;
        // if (!e.target.src.match('svg')) return this.imageLoading = false;
        // this.imageLoading = false;
    }

    clearSelection() {
        this.filter = '';
        this.applyFilter('');
    }

    async onImportClick() {
        if (!this.selectedResource) return;
        this.imageLoading = true;
        const newResourceId = await this.importService.importResource(this.selectedResource.businessId, this.selectedResource.resourceId);

        if (this.itemSelected) {
            this.itemSelected.emit(newResourceId);
        }
        if (!this.dialogGetAsset) {
            this.router.navigateByUrl('/resources/list');
        }
        setTimeout(() => {
            this.onClose();
        }, 333);
    }

    onClose() {
        this.imageLoading = true;
        this.helpModalDiag.close();
    }
}

/**
 fetch('https://upload.wikimedia.org/wikipedia/commons/7/77/Delete_key1.jpg')
 .then(res => res.blob()) // Gets the response and returns it as a blob
 .then(blob => {
    // Here's where you get access to the blob
    // And you can use it for whatever you want
    // Like calling ref().put(blob)

    // Here, I use it to make an image appear on the page
    let objectURL = URL.createObjectURL(blob);
    let myImage = new Image();
    myImage.src = objectURL;
    // document.getElementById('myImg').appendChild(myImage)
});

 fetch(this.selectedResource.url)
 .then(r => r.blob())
 .then(blobFile => {
    let f = new File([blobFile], "new resource", { type: "image/png" });
    const totalByte = f.size;
});
 **/
